export interface IFiltersData {
  id: string;
  title: string;
  value: string;
}

export const filtersData: Array<IFiltersData> = [
  {id: '1', title: 'جدیدترین', value: 'created_at'},
  {id: '2', title: 'پربازدیدترین', value: 'view_count'},
  {id: '3', title: 'نزدیک‌ترین ', value: 'distance'},
  {id: '4', title: ' محبوب‌ترین', value: 'average_rate'},
];
export const multiSelectData: Array<IFiltersData> = [];
